import React, { useMemo } from 'react';
import cn from 'classnames';
import Modal from '@components/common/Modal';
import styles from '../orders.module.scss';
import PropTypes from 'prop-types';


const PrintReceiptLoadingModal = ({serverAppTheme, ...props}) => {
  const popupModal = useMemo(() => {
    const modalStyle = {
      backgroundColor:serverAppTheme?.popUp_bg,
      border:serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
      borderRadius:"16px"
    }
    const nameStyle = {color: serverAppTheme?.primary_text}

    return {modalStyle, nameStyle}
  },[serverAppTheme])

    return (
        <Modal
        isOpen={props.isPrintOpen}
        isModalCenter
        noBackground  
        style={popupModal.modalStyle}
      >
        <div className="col-12 my-2 fs-16 justify-content-center align-items-center position-relative text-center " style={popupModal.nameStyle}>
          <div>
            {/* <div className="text-left">Printer IP Address :{props.printData?.printerIpAddress}</div><br /> */}
            <br/><br/>
            <div className="text-left fs_18">Printer Name: {props.printData?.printerName}</div><br /><br/>
            {/* <div className="text-left">Printer Port: {props.printData?.printerPort} </div> */}
          </div>
          <div className={cn(styles.imgSpin, 'od-spinner position-absolute')} />
        </div>
      </Modal>
    )
}
PrintReceiptLoadingModal.propTypes = {
  serverAppTheme: PropTypes.object,
  isPrintOpen: PropTypes.bool,
  printData: PropTypes.object,
}
PrintReceiptLoadingModal.defaultProps = {
  serverAppTheme: {},
  isPrintOpen: false,
  printData: {},
};

export default PrintReceiptLoadingModal;